const ManageConsent = (function ($, fed) {
    window.dataLayer = window.dataLayer || [];
    const self = {
        httpStatusCode: {
            OK: 200,
            Created: 201,
            UnprocessableEntity: 422,
            LoginTimeout: 440,
            BadGateway: 502
        },
        gtm: {
            submitButtonClickEventState: function (status) {
                const href = document.location.href.split('/');
                return {
                    event: 'ga_event',
                    category: 'form submission',
                    action: status,
                    label: href[href.length - 1] + ' form',
                    value: 0,
                    nonInteraction: 0
                };
            }
        },
        elements: {
            buttons: {
                Email: '#marketing-preferences-email',
                Post: '#marketing-preferences-post',
                Sms: '#marketing-preferences-sms',
                SocialMedia: '#marketing-preferences-social-media',
                Telephone: '#marketing-preferences-telephone',
                VitalityMagazine: '#marketing-tips-magazine',
                VitalityNewsletter: '#marketing-tips-newsletter',
                PartnerEmail: '#marketing-tips-partner-emails',
                VitalityCompetition: '#marketing-competions-promotions',
                SubmitButton: '#manageconsent-submit-button',
                PreferenceUpdatedModalClose: '#preference-updated .vds-modal__close',
                PreferenceUpdatedOkButton: '#preference-updated-button'
            },
            ids: {
                PreferenceUpdatedModal: 'preference-updated',
                ErrorNotification: '#manage-consent-error'
            }
        },
        urls: {
            SetConsentUrl: '/api/sitecore/Consent/SetMemberConsent',
            ErrorPage: '/error/error-page'
        },
        func: {
            init: function () {
                self.func.bindEvents();
            },
            bindEvents: function () {
                $(self.elements.buttons.SubmitButton).on('click', self.func.handleSubmitButtonClick);
                $(self.elements.buttons.PreferenceUpdatedModalClose).on('click', self.func.helpers.reloadPage);
                $(self.elements.buttons.PreferenceUpdatedOkButton).on('click', self.func.helpers.reloadPage);
            },
            handleSubmitButtonClick: function () {
                const data = {
                    VitalityMagazine: $(self.elements.buttons.VitalityMagazine).is(':checked'),
                    VitalityNewsletter: $(self.elements.buttons.VitalityNewsletter).is(':checked'),
                    PartnerEmail: $(self.elements.buttons.PartnerEmail).is(':checked'),
                    VitalityCompetition: $(self.elements.buttons.VitalityCompetition).is(':checked'),
                    Telephone: $(self.elements.buttons.Telephone).is(':checked'),
                    SocialMedia: $(self.elements.buttons.SocialMedia).is(':checked'),
                    Sms: $(self.elements.buttons.Sms).is(':checked'),
                    Post: $(self.elements.buttons.Post).is(':checked'),
                    Email: $(self.elements.buttons.Email).is(':checked')
                };
                self.func.setConsent(data);
            },
            setConsent: function (data) {
                $.ajax({
                    type: 'GET',
                    url: self.urls.SetConsentUrl,
                    data: data,
                    success: self.func.setMemberConsentSuccess,
                    error: self.func.setMemberConsentError
                });
            },
            setMemberConsentSuccess: function (data) {
                if (data.statusCode === self.httpStatusCode.OK) {
                    window.dataLayer.push(self.gtm.submitButtonClickEventState('success'));
                    self.func.openPreferenceUpdatedModal();
                }
            },
            setMemberConsentError: function (data) {
                window.dataLayer.push(self.gtm.submitButtonClickEventState('failure'));
                if (data.statusCode === self.httpStatusCode.UnprocessableEntity) {
                    $(self.elements.ids.ErrorNotification).show();
                } else {
                    self.func.redirectToErrorPage();
                }
            },
            redirectToErrorPage: function () {
                self.func.helpers.redirect(self.urls.ErrorPage);
            },
            openPreferenceUpdatedModal: function () {
                self.func.helpers.openModal(self.elements.ids.PreferenceUpdatedModal);
            },
            helpers: {
                reloadPage: function () {
                    window.location.reload(true);
                },
                redirect: function (url) {
                    window.location.replace(url);
                },
                openModal: function (id) {
                    fed.openModal(id);
                },
                closeModal: function (id) {
                    fed.closeModal(id);
                }
            }
        }
    };

    return {
        init: self.func.init
    };
})(jQuery, {openModal: openModal, closeModal: closeModal});

$('document').ready(function () {
    if ('manageconsent' === $('#page-data').data('feature')) {
        ManageConsent.init();
    }
});
